
import React, { useState, useRef, useEffect } from "react";
import { motion } from 'framer-motion';
import Webcam from 'react-webcam';
import { useNavigate } from 'react-router-dom';
import MobileImg from './AttendanceImg/Mobile_device_Image.png'
import { decryptToken } from "../utils/getToken";
import { useSidebar } from "../../SidebarContext";

const GOOGLE_API_KEY = "AIzaSyD0AcxoBWhqkMIAfK-F-X6ya3Es-52o1YU";

const AttendanceUpdated = () => {
    const { isSidebarOpen } = useSidebar();
    const [isCheckedIn, setIsCheckedIn] = useState(false);
    const [isCheckedOut, setIsCheckedOut] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isCheckingIn, setIsCheckingIn] = useState(false);
    const [isCheckingOut, setIsCheckingOut] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [location, setLocation] = useState('');
    const [selfie, setSelfie] = useState(null);
    const webcamRef = useRef(null);
    const containerRef = useRef(null);
    const login = JSON.parse(localStorage.getItem("creditmain")) || {};
    const [attendanceData, setAttendanceData] = useState([]);
    const [showAllActivities, setShowAllActivities] = useState(false);
    const [sessionMode, setSessionMode] = useState("single");
    const [todayState, setTodayState] = useState({
        canCheckIn: true,
        canCheckOut: false,
        sessionsToday: 0,
        openSessionId: null,
    });
    const [todayDisplayRow, setTodayDisplayRow] = useState(null);
    const navigate = useNavigate();
    const url = process.env.REACT_APP_LINK;
    const token = decryptToken("accessToken") || ""
    const captureImage = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        setSelfie(imageSrc);
    };

    const getFormattedLocation = async (lat, lng) => {
        try {
            const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_API_KEY}`);
            const data = await response.json();
            if (data.status === 'OK') {
                return data.results[0]?.formatted_address || "Unknown Area";
            }
        } catch (error) {
            console.error("Error fetching location:", error);
        }
        return "Unknown Area";
    };

    const handleRetake = () => setSelfie(null);

    const handleCheckInSubmit = async () => {
        if (!selfie?.startsWith('data:image')) return;
        setIsSubmitting(true); // 🔁 Start loading
        try {
            const response = await fetch(selfie);
            const blob = await response.blob();
            const file = new File([blob], 'selfie.jpg', { type: 'image/jpeg' });

            const data = new FormData();
            data.append('checkin_location', location);
            data.append('selfie', file);
            data.append('staff_name', login.firstName);
            data.append('staff_id', login.emplyee_ID);
            data.append('check_in_from', 'Office');

            const result = await fetch(`${url}/staffattendance/admin1997`, {
                method: 'POST',
                body: data,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (result.ok) {
                localStorage.setItem("staffCheckinStatus", "yes");
                localStorage.setItem("checkinDate", new Date().toDateString());

                setShowModal(false);
                setSelfie(null);

                fetchStaffAttendance();
            } else {
                const errBody = await result.json().catch(() => ({}));
                alert(errBody.message || "Check-in failed. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting check-in:", error);
        } finally {
            setIsSubmitting(false); // ✅ Stop loading
        }
    };


    const handleCheckOutSubmit = () => {
        return new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition(async (pos) => {
                const { latitude, longitude } = pos.coords;
                const area = await getFormattedLocation(latitude, longitude);
                const checkoutDate = new Date().toISOString();

                const data = {
                    checkout_date: checkoutDate,
                    checkout_location: area,
                    check_out_from: "Office"
                };

                try {
                    const response = await fetch(`${url}/staffattendance/checkout-open`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            "Authorization": `Bearer ${token}`
                        },
                        body: JSON.stringify(data)
                    });

                    if (response.ok) {
                        setShowModal(false);
                        setSelfie(null);
                        fetchStaffAttendance();
                    } else {
                        const errBody = await response.json().catch(() => ({}));
                        alert(errBody.message || errBody.error || "Check-out failed.");
                    }
                } catch (error) {
                    console.error("Checkout failed:", error);
                } finally {
                    resolve(); // mark promise done
                }
            }, (err) => {
                console.error("Geolocation error:", err);
                alert("Please allow location access to check out.");
                resolve();
            });
        });
    };


    const handleDragEnd = (e, info) => {
        const threshold = containerRef.current.offsetWidth * 0.8;
        if (info.offset.x > threshold) {
            if (!isCheckedIn) {
                navigator.geolocation.getCurrentPosition(
                    async (pos) => {
                        const { latitude, longitude } = pos.coords;
                        const area = await getFormattedLocation(latitude, longitude);
                        setLocation(area);
                        setShowModal(true);
                    },
                    (err) => {
                        console.error("Geolocation error:", err);
                        alert("Location access is required.");
                        setLocation("Unknown Area");
                        setShowModal(true);
                    }
                );
            } else {
                handleCheckOutSubmit();
            }
        }
    };

    const fetchStaffAttendance = async () => {
        try {
            const res = await fetch(`${url}/staffattendance/all`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const datamain = await res.json();
            const data = Array.isArray(datamain.data) ? datamain.data : [];
            const mode = datamain.sessionMode === "multi" ? "multi" : "single";
            const state = datamain.todayState || {};
            setSessionMode(mode);
            setTodayState({
                canCheckIn: Boolean(state.canCheckIn),
                canCheckOut: Boolean(state.canCheckOut),
                sessionsToday: Number(state.sessionsToday) || 0,
                openSessionId: state.openSessionId ?? null,
            });

            const sorted = [...data].sort(
                (a, b) => new Date(b.checkin_date) - new Date(a.checkin_date)
            );
            setAttendanceData(sorted);

            const today = new Date().toDateString();
            const todayRows = sorted.filter(
                (entry) => new Date(entry.checkin_date).toDateString() === today
            );
            const openToday = todayRows.find((r) => !r.checkout_date);
            const betweenSessions =
                Boolean(state.canCheckIn) &&
                !state.canCheckOut &&
                (Number(state.sessionsToday) || 0) > 0;
            let displayRow = openToday;
            if (!displayRow && !betweenSessions) {
                displayRow = todayRows[0] || null;
            } else if (betweenSessions) {
                displayRow = null;
            }
            setTodayDisplayRow(displayRow);

            setIsCheckedIn(Boolean(state.canCheckOut));
            setIsCheckedOut(!state.canCheckIn && !state.canCheckOut && (state.sessionsToday || 0) > 0);

            if (!state.canCheckOut && !state.canCheckIn && (state.sessionsToday || 0) === 0) {
                localStorage.removeItem("staffCheckinStatus");
                localStorage.removeItem("checkinDate");
            }

        } catch (error) {
            console.error("Failed to fetch attendance:", error);
        }
    };

    useEffect(() => {
        fetchStaffAttendance();
    }, []);

    const getAreaOnly = (address) => {
        if (!address) return '';
        const parts = address.split(',');
        const area = parts.find(part => part.includes('('));
        return area ? area.trim() : parts[2]?.trim() || '';
    };

    return (
        <>
            <div className={`open-close ${isSidebarOpen ? "open" : "closed"}`}>
                {/* Header */}
                <div className="flex items-center justify-between">
                    <h1 className="dashboard-title">Attendance</h1>
                </div>
                <div className="attendance-desktop-screen">
                    <img src={MobileImg} alt="" />
                    <h2>Use a mobile device for attendance.</h2>
                </div>
                <div className="attendance-mobile-screen">
                    <div className="attendance-main-heading-oms">
                        <h1>Today's Attendance</h1>
                        {sessionMode === "multi" && todayState.sessionsToday > 0 && (
                            <p style={{ margin: "0.35rem 0 0", fontSize: "0.875rem", color: "#64748b" }}>
                                {todayState.canCheckOut
                                    ? `Session ${todayState.sessionsToday} — checked in`
                                    : `${todayState.sessionsToday} session${todayState.sessionsToday === 1 ? "" : "s"} today`}
                            </p>
                        )}
                    </div>

                    <div className="attendance-update-header">
                        <div className="attendance-card-header">
                            <div className="attendance-card-header-icons">
                                <i className="fa-solid fa-arrow-right-to-bracket"></i> Check In
                            </div>
                            <div className="attendance-time-and-add-card-header">
                                <h2>
                                    {todayDisplayRow?.checkin_date
                                        ? new Date(todayDisplayRow.checkin_date).toLocaleTimeString('en-GB', {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            hour12: false
                                        })
                                        : '--'}
                                </h2>
                                <p>
                                    {getAreaOnly(todayDisplayRow?.checkin_location) || 'NA'}
                                    {todayDisplayRow?.checkin_location && (
                                        <i className="fa fa-info-circle ms-2" style={{ color: "#1a73e8", cursor: "pointer" }} title={todayDisplayRow.checkin_location}></i>
                                    )}
                                </p>
                            </div>
                        </div>

                        <div className="attendance-card-header">
                            <div className="attendance-card-header-icons">
                                <i className="fa-solid fa-arrow-right-to-bracket checkout-icon"></i> Check Out
                            </div>
                            <div className="attendance-time-and-add-card-header">
                                <h2>
                                    {todayDisplayRow?.checkout_date
                                        ? new Date(todayDisplayRow.checkout_date).toLocaleTimeString('en-GB', {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            hour12: false
                                        })
                                        : 'Working...'}
                                </h2>
                                <p>
                                    {getAreaOnly(todayDisplayRow?.checkout_location) || 'NA'}
                                    {todayDisplayRow?.checkout_location && (
                                        <i className="fa fa-info-circle ms-2" style={{ color: "#1a73e8", cursor: "pointer" }} title={todayDisplayRow.checkout_location}></i>
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>

                    {todayState.canCheckIn && (
                        <div className="attendance-swipe-oms">
                            <button
                                className="attendance-click-btn-oms"
                                disabled={isCheckingIn}
                                onClick={() => {
                                    setIsCheckingIn(true);
                                    navigator.geolocation.getCurrentPosition(
                                        async (pos) => {
                                            const { latitude, longitude } = pos.coords;
                                            const area = await getFormattedLocation(latitude, longitude);
                                            setLocation(area);
                                            setShowModal(true);
                                            setIsCheckingIn(false);
                                        },
                                        (err) => {
                                            console.error("Geolocation error:", err);
                                            alert("Location access is required.");
                                            setLocation("Unknown Area");
                                            setShowModal(true);
                                            setIsCheckingIn(false);
                                        }
                                    );
                                }}
                            >
                                <i class="animation"></i>{isCheckingIn ? <span className="spinner"></span> : "Click to Check In"}<i class="animation"></i>
                            </button>

                        </div>
                    )}


                    {todayState.canCheckOut && (
                        <div className="attendance-swipe-oms">
                            <button
                                className="attendance-click-btn-oms"
                                disabled={isCheckingOut}
                                onClick={() => {
                                    setIsCheckingOut(true);
                                    handleCheckOutSubmit().finally(() => setIsCheckingOut(false));
                                }}
                            >
                                <i class="animation"></i>{isCheckingOut ? <span className="spinner"></span> : "Click to Check Out"} <i class="animation"></i>
                            </button>

                        </div>
                    )}


                    <div className="attendance-updated-activity-oms">
                        <div className="my-attendance-head-and-button">
                            <h3>My activity</h3>
                            {attendanceData.length > 10 && (
                                <button onClick={() => navigate('/all-attendance', { state: { attendanceData } })} className="view-more-activity-btn-oms">
                                    View All
                                </button>
                            )}
                        </div>

                        <div className="attendance-updated-lists-oms">
                            {(showAllActivities ? attendanceData : attendanceData.slice(0, 10)).map((activity, index) => (
                                <div key={index} className="attendance-updated-activity-list-oms">
                                    <img src={`${url}/${activity.selfie}`} alt="Selfie" />
                                    <p className="attendance-updated-status-oms">
                                        <span>{activity.login_status || 'N/A'}</span><br />
                                        <span>{new Date(activity.checkin_date).toLocaleDateString()}</span>
                                    </p>
                                    <p className="checkin-checkout-time">
                                        <span>In time: {new Date(activity.checkin_date).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })}</span><br />
                                        <span>Out time: {activity.checkout_date ? new Date(activity.checkout_date).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }) : 'Working...'}</span>
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {showModal && (
                        <div className="swipe-modal-check-in-oms">
                            <div className="swipe-modal-content-oms">
                                <button
                                    onClick={() => {
                                        setShowModal(false);
                                        window.location.reload();
                                    }}
                                    className="swipe-modal-content-close"
                                    aria-label="Close"
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </button>

                                <h2>Check-In Details</h2>
                                <input type="text" value={location} readOnly style={{ width: '100%' }} />

                                {!selfie ? (
                                    <div>
                                        <Webcam
                                            audio={false}
                                            ref={webcamRef}
                                            screenshotFormat="image/jpeg"
                                            mirrored={true}
                                            style={{
                                                width: '100%',
                                                marginTop: 10,
                                                objectFit: 'cover',
                                                borderRadius: 10
                                            }}
                                        />
                                        <button onClick={captureImage} className="capture-selfie-oms">
                                            Capture Selfie
                                        </button>
                                    </div>
                                ) : (
                                    <img src={selfie} alt="Selfie" style={{ width: '100%', marginTop: 10 }} />
                                )}

                                <div className="swipe-modal-actions-oms">
                                    {selfie && (
                                        <>
                                            <button onClick={handleRetake}>Retake</button>
                                            <button onClick={handleCheckInSubmit} disabled={isSubmitting}>
                                                {isSubmitting ? (
                                                    <span className="spinner"></span>
                                                ) : (
                                                    "Submit"
                                                )}
                                            </button>


                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default AttendanceUpdated;